import { useState, useEffect, useCallback, useRef } from 'react';

const useDimensions = () => {
  const [dimensions, setDimensions] = useState(() => ({
    width: window.innerWidth,
    height: window.innerHeight,
  }));

  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleResize = useCallback(() => {
    // Debounce resize events to prevent excessive rerenders
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      setDimensions((prev) => {
        // Only update if dimensions actually changed
        if (
          prev.width !== window.innerWidth ||
          prev.height !== window.innerHeight
        ) {
          return {
            width: window.innerWidth,
            height: window.innerHeight,
          };
        }
        return prev;
      });
      timeoutRef.current = null;
    }, 16); // ~60fps throttling
  }, []);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [handleResize]);

  return dimensions;
};

export default useDimensions;
